import { AxiosResponse } from 'axios'
// import { setObjectItemToFixed } from '@/utils'
import domain from '../config'
import { message } from 'antd'

// 401 未登录 403 无权限
export default {
    // `url` is the server URL that will be used for the request
    url: '',

    // `method` is the request method to be used when making the request
    method: 'post', // default

    // `baseURL` will be prepended to `url` unless `url` is absolute.
    // It can be convenient to set `baseURL` for an instance of axios to pass relative URLs
    // to methods of that instance.
    baseURL: process.env.REACT_APP_SERVER_IP,

    reqInterceptor: [
        function (config: any) {
            // Do something before request is sent
            return config
        },
        function () {
            // Do something with request error
            console.error('数据发送失败，检查网络配置')

            return Promise.reject('数据发送失败，检查网络是否断开连接')
        },
    ],

    repInterceptor: [
        function (response: AxiosResponse) {
            return response.data.data
        },
        function (e: any) {
            try {
                if (e.response.status === 401) {
                    window.location.href = domain.passport + '/#/login?oa=new_ls'
                }

                if (e.response.status === 403) {
                    message.error('暂无该店铺权限，请联系超管开启')
                    setTimeout(() => {
                        window.location.href = domain.centerMobileUrl + '/#/shopList'
                    }, 500)
                }
                // Do something with response error
                // return Promise.reject({ message: '网络错误: ' + e })
                e.response.data = e.response.data || {}
                e.response.data.response = e

                if (e.response.status === 502) {
                    return Promise.reject({ message: '服务器升级中，请稍后再试' })
                }

                if (e.response.status === 504) {
                    return Promise.reject({ message: '网络不可用，请检查网络设置' })
                }

                return Promise.reject(e.response.data)
            } catch (e) {
                return Promise.reject({ message: '网络不可用，请检查网络设置' })
            }
        },
    ],

    // `transformRequest` allows changes to the request data before it is sent to the server
    // This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
    // The last function in the array must return a string or an instance of Buffer, ArrayBuffer,
    // FormData or Stream
    // You may modify the headers object.
    // transformRequest: [function(data, headers) {
    //     // Do whatever you want to transform the data

    //     return data
    // }],

    // `transformResponse` allows changes to the response data to be made before
    // it is passed to then/catch
    // transformResponse: [function(data) {
    //     // Do whatever you want to transform the data
    //     return data
    // }],

    // `headers` are custom headers to be sent
    headers: {
        Source: window.location.href,
    },

    // `params` are the URL parameters to be sent with the request
    // Must be a plain object or a URLSearchParams object
    // params: {
    //     ID: 12345
    // },

    // `paramsSerializer` is an optional function in charge of serializing `params`
    // (e.g. https://www.npmjs.com/package/qs, http://api.jquery.com/jquery.param/)
    paramsSerializer(params: any) {
        return params
        // return Qs.stringify(params, { arrayFormat: 'brackets' })
    },

    // `data` is the data to be sent as the request body
    // Only applicable for request methods 'PUT', 'POST', and 'PATCH'
    // When no `transformRequest` is set, must be of one of the following types:
    // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
    // - Browser only: FormData, File, Blob
    // - Node only: Stream, Buffer
    // data: {
    //     firstName: 'Fred'
    // },

    // `timeout` specifies the number of milliseconds before the request times out.
    // If the request takes longer than `timeout`, the request will be aborted.
    timeout: 400000, // default is `0` (no timeout)

    // `withCredentials` indicates whether or not cross-site Access-Control requests
    // should be made using credentials
    withCredentials: false, // default

    // `adapter` allows custom handling of requests which makes testing easier.
    // Return a promise and supply a valid response (see lib/adapters/README.md).
    // adapter: function(config) {
    //     /* ... */
    // },

    // `auth` indicates that HTTP Basic auth should be used, and supplies credentials.
    // This will set an `Authorization` header, overwriting any existing
    // `Authorization` custom headers you have set using `headers`.
    // auth: {
    //     username: 'janedoe',
    //     password: 's00pers3cret'
    // },

    // `responseType` indicates the type of data that the server will respond with
    // options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    responseType: 'json', // default

    // `responseEncoding` indicates encoding to use for decoding responses
    // Note: Ignored for `responseType` of 'stream' or client-side requests
    responseEncoding: 'utf8', // default

    // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
    // xsrfCookieName: 'XSRF-TOKEN', // default

    // // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    // xsrfHeaderName: 'X-XSRF-TOKEN', // default

    // `onUploadProgress` allows handling of progress events for uploads
    // onUploadProgress: function(progressEvent) {
    //     // Do whatever you want with the native progress event
    // },

    // `onDownloadProgress` allows handling of progress events for downloads
    // onDownloadProgress: function(progressEvent) {
    //     // Do whatever you want with the native progress event
    // },

    // `maxContentLength` defines the max size of the http response content in bytes allowed
    // maxContentLength: 2000,

    // `validateStatus` defines whether to resolve or reject the promise for a given
    // HTTP response status code. If `validateStatus` returns `true` (or is set to `null`
    // or `undefined`), the promise will be resolved; otherwise, the promise will be
    // rejected.
    validateStatus(status: number) {
        return status >= 200 && status < 300 // default
    },
}
